import { useEffect, useState } from 'react';
import useUserApi, { ErrorHandler } from '../Services/UserApi';
import { EftposBooking } from 'shared-components';

export default function useEftposBookings() {
	const [eftposBookings, setEftposBookings] = useState<EftposBookingWithMarketDetails[]>();

	const userApi = useUserApi();

	useEffect(() => {
		userApi<{ eftposBookings: EftposBookingWithMarketDetails[] }>({
			route: `eftpos/api`,
			data: {
				action: 'getEftposBookings',
			},
			errorMessage: 'Error loading eftpos bookings',
		})
			.then((res) => {
				setEftposBookings(res.data.eftposBookings);
			})
			.catch((e: unknown) => ErrorHandler.toast(e));
	}, [userApi]);

	return { eftposBookings, setEftposBookings };
}

export interface EftposBookingWithMarketDetails extends EftposBooking {
	MarketName: string;
	MarketId: number;
	MarketDate: number;
}
